import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../base.httpservice';
import { Notification } from '../../models/notification';

@Injectable()
export class NotificationsHttpService extends BaseHttpService {
	protected readonly endpoint = this.apiUrl('notifications');

	constructor(http: HttpClient) {
		super(http);
	}

	load(): Observable<Notification[]> {
		return this.http.get<Notification[]>(`${this.endpoint}/list`);
	}

	markAsRead(id: string): Observable<any> {
		return this.http.post(`${this.endpoint}/${id}/read`, {});
	}

	markAllAsRead(): Observable<any> {
		return this.http.post(`${this.endpoint}/read-all`, {});
	}
}
